import { render, staticRenderFns } from "./reference-clients.vue?vue&type=template&id=744484b2&scoped=true&"
import script from "./reference-clients.vue?vue&type=script&lang=js&"
export * from "./reference-clients.vue?vue&type=script&lang=js&"
import style0 from "./reference-clients.vue?vue&type=style&index=0&id=744484b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744484b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744484b2')) {
      api.createRecord('744484b2', component.options)
    } else {
      api.reload('744484b2', component.options)
    }
    module.hot.accept("./reference-clients.vue?vue&type=template&id=744484b2&scoped=true&", function () {
      api.rerender('744484b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reference-clients.vue"
export default component.exports